var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["HeaderLink.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["title"], 
["link", "linkMessage"], 
function (l_title, kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("title", l_title);
frame.set("link", kwargs.hasOwnProperty("link") ? kwargs["link"] : "");
frame.set("linkMessage", kwargs.hasOwnProperty("linkMessage") ? kwargs["linkMessage"] : "Подробнее");
var t_2 = "";t_2 += "<a class=\"HeaderLink u-Heading\" href=\"";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "link")), env.opts.autoescape);
t_2 += "\" target=\"_blank\">\n        <span class=\"HeaderLink-linkContents\">\n            <span class=\"HeaderLink-titleContainer\">\n                <span class=\"HeaderLink-title\">";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, l_title), env.opts.autoescape);
t_2 += "</span>\n            </span>\n            <span class=\"HeaderLink-linkMessage\">";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "linkMessage"), env.opts.autoescape);
t_2 += "</span>\n        </span>\n    </a>";
t_2 += runtime.suppressValue((lineno = 8, colno = 15, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("HeaderLink");
context.setVariable("HeaderLink", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["HeaderLink.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/HeaderLink/HeaderLink.jinja
// module id = 80
// module chunks = 0